import { Inject } from '@angular/core';
import { Component, Input } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { EventsServiceInterface } from '../../services/events/events.interface';
import { IOnboardingTipsService } from '../../services/onboarding-tips/onboarding-tips.interface';

@Component({
  selector: 'gtd-help-menu',
  templateUrl: './help-menu.component.html',
})
export class HelpMenuComponent {
  @Input() cssClass = '';
  public knowledgeBaseLink = $localize`:@@common.knowledge_base_link:https://support.irev.com/en/categories/423106-affiliate-area`;
  public onboardingStatus = new UntypedFormControl();

  constructor(
    @Inject('EventsServiceInterface') private eventsService: EventsServiceInterface,
    @Inject('IOnboardingTipsService') private onboardingTipsService: IOnboardingTipsService
  ) {
    this.onboardingStatus.patchValue(JSON.parse(localStorage.getItem('isOnboardingWorking')));

    this.onboardingStatus.valueChanges.subscribe((status: boolean) => {
      this.onboardingTipsService.setWorkingStatus(status);
    });

    this.onboardingTipsService.stateChanges().subscribe(() => {
      if (this.onboardingTipsService.getWorkingStatus() !== this.onboardingStatus.value) {
        this.onboardingStatus.patchValue(this.onboardingTipsService.getWorkingStatus());
      }
    });
  }

  openDocsBoard() {
    this.eventsService.broadcast('docs:open');
  }
}
